// removed by extract-text-webpack-plugin
module.exports = {"stream":"_35B6A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LiveStream/LiveStream.scss
// module id = ./src/components/LiveStream/LiveStream.scss
// module chunks = 4